let all = {
    "list": [{
            "name": "北京",
            "value": "87739"
        },
        {
            "name": "天津",
            "value": "55292"
        },
        {
            "name": "河北",
            "value": "626624"

        },
        {
            "name": "山西",
            "value": "311743"
        },
        {
            "name": "河南",
            "value": "442086"
        },
        {
            "name": "山东",
            "value": "658190"
        },
        {
            "name": "上海",
            "value": "153778"
        },
        {
            "name": "江苏",
            "value": "410819"
        },
        {
            "name": "浙江",
            "value": "184441"
        },
        {
            "name": "福建",
            "value": "86433"
        },
        {
            "name": "安徽",
            "value": "369905"
        },
        {
            "name": "江西",
            "value": "229305"
        },
        {
            "name": "湖北",
            "value": "159925"
        },
        {
            "name": "湖南",
            "value": "125319"
        }, {
            "name": "广东",
            "value": "294136"
        },
        {
            "name": "广西",
            "value": "161948"
        }, {
            "name": "贵州",
            "value": "50058"
        },
        {
            "name": "云南",
            "value": "127109"
        }, {
            "name": "海南",
            "value": "11859"
        }, {
            "name": "黑龙江",
            "value": "133170"
        },
        {
            "name": "吉林",
            "value": "126851"
        },
        {
            "name": "辽宁",
            "value": "246954"
        },
        {
            "name": "陕西",
            "value": "151355"
        },
        {
            "name": "新疆",
            "value": "38100"
        },
        {
            "name": "青海",
            "value": "21398"
        },
        {
            "name": "内蒙古",
            "value": "91927"
        },
        {
            "name": "宁夏",
            "value": "64464"
        },
        {
            "name": "甘肃",
            "value": "80243"
        }, {
            "name": "四川",
            "value": "225984"
        },
        {
            "name": "西藏",
            "value": "4083"
        },
        {
            "name": "重庆",
            "value": "142899"
        }
    ]
}
let num = 0;
for(let i = 0 ;i<all.list.length;i++){
    num+=all.list[i].value*1
}
all.list.unshift({
    name:'合计',
    value:num
})
export default all
